/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Geolocation API URLs
 * GEO_PATH is Deskshare's own backend endpoint that resolves IP geolocation
 * against a self-hosted MaxMind GeoLite2 database. No visitor data leaves
 * Deskshare infrastructure. The former browser-side Nominatim reverse-geocoding
 * path (LocationDetails.ts) was removed; state and postal code now come from
 * the same server-side GeoIP response.
 */
export const EXTERNAL_APIS = {
  /**
   * Internal geolocation endpoint — returns ip, org, city, country, lat/lng.
   * Full URL is built in IPDetails.ts using configuration.backendURL.
   */
  GEO_PATH: "/api/geo/",
} as const;

/**
 * Social Media URLs
 * DeskShare's official social media profiles
 */
export const SOCIAL_MEDIA = {
  FACEBOOK: "https://www.facebook.com/people/Deskshare/100064110930535/",
  YOUTUBE: "https://www.youtube.com/@DeskShareInc",
} as const;

/**
 * DD-12: Centralized language constants — single source of truth.
 *
 * Previously defined independently in i18n.ts, main.tsx, and AddLanguagePath.ts
 * with inconsistent contents. Adding a new language now requires changing only
 * this file.
 *
 * ALL_LANGUAGES    — every supported locale (used by i18n config)
 * URL_LANGUAGES    — locales that get a URL prefix (/de/, /fr/, etc.)
 *                    English is excluded — it uses the root path /
 */
export const ALL_LANGUAGES = ["en", "de", "es", "fr", "it", "pt"] as const;
export type SupportedLanguage = (typeof ALL_LANGUAGES)[number];

export const URL_LANGUAGES = ["de", "es", "fr", "it", "pt"] as const;
export type UrlLanguage = (typeof URL_LANGUAGES)[number];
